module.exports = __webpack_public_path__ + "img/logo.aa591532.png";